import HomeHero from "@/components/home/HomeHero";
import HomeAbout from "@/components/home/HomeAbout";
import HomeShowroom from "@/components/home/HomeShowroom";
import HomeCategories from "@/components/home/HomeCategories";
import HomeBrands from "@/components/home/HomeBrands";
import HomeFinalCTA from "@/components/home/HomeFinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HomeHero />
      <HomeAbout />
      <HomeShowroom />
      <HomeCategories />
      <HomeBrands />
      <HomeFinalCTA />
    </div>
  );
}
